import React, { useState } from "react";
import { Form, Button, Alert, Container } from "react-bootstrap";
import api from "../api";
import { useNavigate } from "react-router-dom";  
import { useEffect } from "react";

const LoginForm = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();  // ✅ Initialize navigation

  useEffect(() => {
    // if the user is already authenticated, redirect
    const checkAuth = async () => {
      try {
        const res = await api.get("/auth/me", { withCredentials: true });
        if (res.data.authenticated) {
          navigate("/admin"); // ✅ Redirect to admin events
        }
      } catch (err) {
        // not authenticated → do nothing
      }
    };

    checkAuth();
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post(`/auth/login`, {
        email,
        password
      }, { withCredentials: true });
      
      if (res.data.success) {
        await onLogin();         // ✅ Update parent auth state
        navigate("/admin");      // ✅ Redirect to admin
      }
    } catch (err) {
      setError("Login failed");
    }
  };

  return (
    <Container className="mt-5 m-3 p-3 shadow rounded comic-neue" style={{ maxWidth: 400 }}>
      <h4 className="mb-3 text-center"><strong>Login</strong></h4>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleLogin}>
        <Form.Group>
          <Form.Label>Email</Form.Label>
          <Form.Control type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </Form.Group>
        <Form.Group className="mt-2">
          <Form.Label>Password</Form.Label>
          <Form.Control type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        </Form.Group>
        <Form.Group className="text-center">
          <Button type="submit" className="mt-3" variant="secondary">Let's go</Button>
        </Form.Group>
      </Form>
    </Container>
  );
};

export default LoginForm;
